import React, { useCallback } from 'react';

import { EditOutlined } from '@ant-design/icons';
import { ButtonAction } from '@fastlessjs/backoffice-layer/dist/components/atoms';
import { List } from '@fastlessjs/backoffice-layer/dist/components/templates';
import debug from '@fastlessjs/backoffice-layer/dist/utils/debug';
import { Modal } from 'antd';

import AddReturnForm, { ReturnFormData } from './AddReturnForm';
import { t } from '../../config/translations';
import { orderLineSchema } from '../../orders/schemas';
import { OrderLine, ReturnOrderLine } from '../../orders/types';

// Register this component for debug tracking
debug.registerComponent('EditReturnLine');

type EditReturnLineProps = {
  onAddReturn: (record: ReturnOrderLine) => void;
  record: ReturnOrderLine;
  isOpenModal: boolean;
  setIsOpenModal: (isOpen: boolean) => void;
};

export const EditReturnLine = (props: EditReturnLineProps) => {
  debug.trackRender('EditReturnLine');
  const { record, onAddReturn, isOpenModal, setIsOpenModal } = props;
  debug.log('EditReturnLine', `Rendering for nart: ${record?.nart}`);

  const handleOpen = useCallback(() => {
    setIsOpenModal(true);
  }, []);

  const handleClose = useCallback(() => {
    setIsOpenModal(false);
  }, []);

  const handleSubmit = useCallback(
    (formData: ReturnFormData) => {
      debug.log('EditReturnLine', `Updating return for nart: ${record?.nart}`);
      onAddReturn({ ...record, ...formData, qret: String(formData.qret) });
      setIsOpenModal(false);
    },
    [onAddReturn, record],
  );

  return (
    <>
      <ButtonAction
        title={t('button.editReturn')}
        icon={<EditOutlined />}
        onClick={handleOpen}
      />
      <Modal
        key={record.nart}
        title={t('modal.returnItem')}
        centered
        width={1200}
        open={isOpenModal}
        onCancel={handleClose}
        footer={null}
      >
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <List<OrderLine>
            data={[record]}
            title={t('list.yourArticle')}
            org=""
            schema={orderLineSchema}
            idKey="nart"
            rowKey={(rawRecord: OrderLine) => rawRecord.nart}
          />
          <div className="focus-container">
            <AddReturnForm
              data={record}
              onSubmit={handleSubmit}
              maxQuantity={parseInt(record.qcde, 10)}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};

// Mark this component as initialized
debug.markInitialized('EditReturnLine');
